import { createSlice } from '@reduxjs/toolkit';

const topicsSlice = createSlice({
  name: 'topics',
  initialState: {
    allTopics: [],
  },
  reducers: {
    setTopics: (state, action) => {
      state.allTopics = action.payload;
    },
  },
});

export const { setTopics } = topicsSlice.actions;
export default topicsSlice.reducer;
